module fdm.common.directives{
    declare var screenfull: any;

    angular.module('fdm.common.directives', [])
        .directive('uiModule', (MODULE_CONFIG, uiLoad, $compile) => {
            return {
                restrict: 'A',
                compile: (el, attrs) => {
                    var contents = el.contents().clone();
                    return (scope, el, attrs) => {
                        el.contents().remove();
                        uiLoad.load(MODULE_CONFIG[attrs.uiModule])
                            .then(() => {
                            $compile(contents)(scope, (clonedElement, scope) => {
                                el.append(clonedElement);
                            }, angular.noop);
                        });
                    }
                }
            };
        })
        .directive('uiShift', ($timeout: ng.ITimeoutService) => {
            return {
                restrict: 'A',
                link: (scope, el, attr) => {
                    // get the $prev or $parent of this el
                    var _el = <any>angular.element(el),
                        _window = angular.element(window),
                        prev = _el.prev(),
                        parent,
                        width = _window.width(),
                        appLayoutMinWidth = 1;

                    !prev.length && (parent = _el.parent());

                    let sm = () => {
                        $timeout(() => {
                            var method = attr.uiShift;
                            var target = attr.target;
                            _el.hasClass('in') || _el[method](target).addClass('in');
                        });
                    }

                    let md = () => {
                        parent && parent['prepend'](el);
                        !parent && _el['insertAfter'](prev);
                        _el.removeClass('in');
                    }

                    if (width < appLayoutMinWidth) {
                        sm()
                    } else {
                        md();
                    }

                    _window.resize(() => {
                        if (width !== _window.width()) {
                            $timeout(() => {
                                if (width < appLayoutMinWidth) {
                                    sm()
                                } else {
                                    md();
                                }
                                width = _window.width();
                            });
                        }
                    });
                }
            };
        })
        .directive('uiToggleClass', ($timeout: ng.ITimeoutService, $document: ng.IDocumentService) => {
            return {
                restrict: 'AC',
                link: (scope, el, attr) => {
                    el.on('click', (e) => {
                        e.preventDefault();
                        var classes = attr.uiToggleClass.split(','),
                            targets = (attr.target && attr.target.split(',')) || Array(el),
                            key = 0;
                        angular.forEach(classes, (_class) => {
                            var target = targets[(targets.length && key)];
                            (_class.indexOf('*') !== -1) && magic(_class, target);
                            angular.element(target).toggleClass(_class);
                            key++;
                        });
                        angular.element(el).toggleClass('active');

                        let magic = (_class, target) => {
                            var patt = new RegExp('\\s' +
                                _class.
                                    replace(/\*/g, '[A-Za-z0-9-_]+').
                                    split(' ').
                                    join('\\s|\\s') +
                                '\\s', 'g');
                            var cn = ' ' + angular.element(target)[0].className + ' ';
                            while (patt.test(cn)) {
                                cn = cn.replace(patt, ' ');
                            }
                            angular.element(target)[0].className = cn.trim();
                        }
                    });
                }
            };
        })
        .directive('uiNav', ($timeout: ng.ITimeoutService) => {
            return {
                restrict: 'AC',
                link: (scope, el, attr) => {
                    var _window = angular.element(window),
                        _mb = 1,
                        wrap = angular.element(document.querySelector('.app-aside')),
                        next,
                        backdrop = '.dropdown-backdrop';
                    // unfolded
                    el.on('click', 'a', function (e) {
                        next && next.trigger('mouseleave.nav');
                        var _this = angular.element(this);
                        //_this.parent().siblings(".active").toggleClass('active');
                        _this.parent().parent().parent().find(".active").not(_this.parent()).toggleClass('active');
                        //_this.next().is('ul') && _this.parent().toggleClass('active') && e.preventDefault();
                        _this.next().is('ul') && _this.parent().toggleClass('active');
                        //_this.next().is('nav-item') && _this.parent().toggleClass('active') && e.preventDefault();
                        if (e) {
                            e.preventDefault();
                        }
                        // mobile
                        _this.next().is('ul') || ((_window.width() < _mb) && angular.element(document.querySelector('.app-aside')).removeClass('show off-screen'));
                    });

                    // folded & fixed
                    el.on('mouseenter', 'a', (e) => {
                        next && next.trigger('mouseleave.nav');
                        angular.element('> .nav', wrap).remove();
                        if (!angular.element(document.querySelector('.app-aside-fixed.app-aside-folded')).length
                            || (_window.width() < _mb) || angular.element(document.querySelector('.app-aside-dock')).length)
                            return;
                        var _this = $(e.target)
                            , top
                            , w_h = angular.element(window).height()
                            , offset = 50
                            , min = 150;

                        !_this.is('a') && (_this = _this.closest('a'));
                        if (_this.next().is('ul')) {
                            next = _this.next();
                        } else {
                            return;
                        }

                        _this.parent().addClass('active');
                        top = _this.parent().position().top + offset;
                        next.css('top', top);
                        if (top + next.height() > w_h) {
                            next.css('bottom', 0);
                        }
                        if (top + min > w_h) {
                            next.css('bottom', w_h - top - offset).css('top', 'auto');
                        }
                        next.appendTo(wrap);

                        next.on('mouseleave.nav', (e) => {
                            angular.element(backdrop).remove();
                            next.appendTo(_this.parent());
                            next.off('mouseleave.nav').css('top', 'auto').css('bottom', 'auto');
                            _this.parent().removeClass('active');
                        });

                        angular.element('.smart').length && angular.element('<div class="dropdown-backdrop"/>').insertAfter('.app-aside').on('click', (next: any) => {
                            next && next.trigger('mouseleave.nav');
                        });

                    });

                    wrap.on('mouseleave', (e) => {
                        next && next.trigger('mouseleave.nav');
                        angular.element('> .nav', wrap).remove();
                    });
                }
            };
        })
        .directive('uiScroll', ($location: ng.ILocationService, $anchorScroll) => {
            return {
                restrict: 'AC',
                link: (scope, el, attr) => {
                    el.on('click', (e) => {
                        $location.hash(attr.uiScroll);
                        $anchorScroll();
                    });
                }
            };
        })
        .directive('uiFullscreen', () => {
        return {
            restrict: 'AC',
            template: '<i class="fa fa-expand fa-fw text i-header-icon"></i><i class="fa fa-compress fa-fw text-active i-header-icon"></i>',
            link: (scope, el, attr) => {
                el.addClass('hide');
                //uiLoad.load('js/libs/screenfull.min.js').then(() => {
                if (screenfull.enabled) {
                    el.removeClass('hide');
                }
                el.on('click', () => {
                    var target;
                    attr.target && (target = angular.element(attr.target)[0]);
                    el.toggleClass('active');
                    screenfull.toggle(target);
                });
                //});
            }
        };
        })
        .directive('uiButterbar', ($rootScope: ng.IRootScopeService, $anchorScroll: ng.IAnchorScrollService) => {
            return {
                restrict: 'AC',
                template: '<span class="bar"></span>',
                link: (scope, el, attrs) => {
                    el.addClass('butterbar hide');
                    scope.$on('$stateChangeStart', (event) => {
                        if (!event.defaultPrevented) {
                            $anchorScroll();
                            el.removeClass('hide').addClass('active');
                        }
                    });
                    scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState) => {
                        event.targetScope.$watch('$viewContentLoaded', () => {
                            el.addClass('hide').removeClass('active');
                        })
                    });
                }
            };
        })
        .directive('dgX', function() {
            return function(scope, elem, attrs) {
                attrs.$observe('dgX', function(x: string) {
                    elem.attr('x', x);
                });
            };
        })
        .directive('dgY', function() {
            return function(scope, elem, attrs) {
                attrs.$observe('dgY', function(y: string) {
                    elem.attr('y', y);
                });
            };
        })
        .directive('dgR', function() {
            return function(scope, elem, attrs) {
                attrs.$observe('dgR', function(r: string) {
                    elem.attr('r', r);
                });
            };
        });
}